// eslint-disable-next-line camelcase
__webpack_public_path__ = window.ioappConfig.resourceBasePath?.standalone || __webpack_public_path__;
